import React, { useEffect, useState } from 'react';
import { DistrictSelectPopUp } from '../../shared/DistrictSelectPopUp';
import { Button, Grid } from '@material-ui/core';
import { DistrictsVService } from '../../../services/V2/padre';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export function BankReconciliationCriteria({ model, operatorId, districtId, districtName, setModel, setUseDistricts, useDistricts, submit, errorToast, setLoading, loading }) {
	const [showDistrictsBox, setShowDistrictsBox] = useState<boolean>(false);
	const [selectedDistricts, setSelectedDistricts] = useState<any>([]);
	const [districts, setDistricts] = useState<any[]>([]);
	const [selectAll, setSelectAll] = useState<boolean>(false);
	const [reportDate, setReportDate] = useState<any[]>([]);

	useEffect(() => {
		if (!districtId || !operatorId) return;
		setLoading(true)
		DistrictsVService.districtsVGetAll({
			pageNumber: 1,
			orderBy: "Code",
			orderByDesc: false,
			filters: [{ property: "OperatorId", value: operatorId }]
		})
			.then((x: any) => {
				setDistricts(x.items);
				setLoading(false)
			})
			.catch((x) => { setLoading(false) });
	}, [operatorId, districtId]);// eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (selectedDistricts.length > 0 || districts.length === 0) return;
		if (model != null && model.startDate != null && model.endDate != null) {
			setReportDate([
				model.startDate,
				model.endDate
			])
			setSelectedDistricts(model.districts.map(x => ({ id: x, name: districts.find(d => d.id === x)?.name })))
		} else {
			if (districtId && districtName) {
				setModel({
					...model,
					districts: [districtId],
					operatorId: operatorId
				});
				setSelectedDistricts([{ id: districtId, name: districtName }]);
			};
		}
	}, [districtId, districtName, districts]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if(selectedDistricts.length === 0) return;
		setModel({
			...model,
			districts: selectedDistricts.map((x) => x.id),
		});
	}, [selectedDistricts]); // eslint-disable-line react-hooks/exhaustive-deps

	const handleDistrictsLinkClick = () => {
		setShowDistrictsBox(true);
	};

	const handleChange = (event) => {
		let name = event.target.name;
		let value = event.target.value === '' ? null : event.target.value;

		if (event.target.type === 'checkbox') {
			name = event.target.name;
			value = event.target.checked;
		}

		setModel({
			...model,
			[name]: value,
		});
	};

	const handleDateChange = (event) => {
		if (event === null) event = [null, null]
		event.sort((a, b) => new Date(a) - new Date(b))
		setModel({
			...model,
			startDate: event[0],
			endDate: event[1],
		});

		setReportDate([
			event[0],
			event[1]
		])
	}

	const refreshForm = () => {
		setModel({
			districts: selectedDistricts.map((x) => x.id),
			operatorId: operatorId
		});

		setReportDate([
			null,
			null
		])
	};

	return (
		<>
			<div style={{ marginTop: '40px' }}>
				{showDistrictsBox && (
					<DistrictSelectPopUp
						isOpen={true}
						handleClose={() => {
							setShowDistrictsBox(false);
						}}
						operatorId={operatorId}
						storeSelectedDistricts={setSelectedDistricts}
						districtIds={selectedDistricts}
						districts={districts}
						setDistricts={setDistricts}
						selectAll={selectAll}
						setSelectAll={setSelectAll}
						selectDistrict={null}
					/>
				)}
			</div >
			<Grid container style={{ height: "400px" }}>
				<Grid container>
					<Grid item xs={4} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
						<div style={{ display: "flex" }}>
							<label className='uvp-label'>
								<b>District</b><span>&nbsp;:&nbsp;</span>
								<input
									disabled
									className='uvp-input uvp-label'
									style={{ width: "250px" }}
									onChange={handleChange}
									type="text"
									id="district"
									name="district"
									value={selectedDistricts.length > 0 && selectedDistricts.length === districts.length ? "Districts - All"
										: selectedDistricts.length > 1 ? "Districts - Multiple"
											: selectedDistricts.length === 0 ? "None"
												: selectedDistricts[0]?.name} />
							</label>
						</div>
						<div style={{ display: "flex" }}>
							<label className='uvp-label' style={{ marginTop: "20px" }}>
								<b>Funding Date</b><span>&nbsp;:&nbsp;</span>
								<DateRangePicker onChange={x => handleDateChange(x)} value={reportDate} className={'uvp-date-input'} editable={false} />
							</label>
						</div>
						<div style={{ display: "flex" }}>
							<label className='uvp-label' style={{ marginTop: "20px" }}>
								<input
									className='uvp-checkbox'
									type="checkbox"
									name="useDistricts"
									checked={useDistricts}
									onChange={() => setUseDistricts(!useDistricts)} />
								<b>Separate Report By District</b>
							</label>
						</div>
						<div style={{ display: "flex", marginTop: "10px", marginLeft: "0px" }}>
							<button
								className='uvp-bank-reconciliation-report-button green-button'
								type="button"
								onClick={() => {
									if (selectedDistricts.length === 0) {
										errorToast("Please select at least one district and try again.");
										return;
									}
									if (model.startDate === "" || !model.startDate) {
										errorToast("Please select a start date and try again.");
										return;
									}
									if (model.endDate === "" || !model.endDate) {
										errorToast("Please select an end date and try again.");
										return;
									}
									submit();
								}}
								style={{
									position: "relative",
									margin: "10px 0px 10px 10px",
									padding: "5px 10px",
									width: "120px"
								}}
							>
								Submit
							</button>
							<button
								className='uvp-bank-reconciliation-report-button gray-button'
								type="button"
								onClick={() => {
									refreshForm();
								}}
								style={{
									margin: "10px 0px 10px 10px",
									padding: "5px 10px",
									width: "120px"
								}}
							>
								Reset
							</button>
						</div>
					</Grid>
					<Grid item xs={2} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
						<Grid container style={{ display: "flex", flexDirection: "column" }}>
							<Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }} />
						</Grid>
						<label className='uvp-label' style={{ height: "30px", marginBottom: "0px" }}>
							<Button
								className='clickable'
								onClick={handleDistrictsLinkClick}
								style={{
									color: '#0073A8',
									textTransform: "none",
									fontSize: "12px"
								}}>
								<u>Select Multiple Districts</u>
							</Button>
						</label>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}